// hooks/useChild.js
import { useState, useEffect, useCallback } from 'react';
import { childApi, fileApi } from '../api/childApi';
import { mapChildToComponentData } from '../utils/childDataMapper';

export const useChild = (childId) => {
  const [child, setChild] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const fetchChild = useCallback(async () => {
    try {
      setLoading(true);
      setError(null);
      const data = await childApi.getChildById(childId);
      const mappedData = mapChildToComponentData(data);
      setChild(mappedData);
    } catch (err) {
      setError(err.response?.data?.message || 'Помилка завантаження даних дитини');
      console.error('Error fetching child:', err);
    } finally {
      setLoading(false);
    }
  }, [childId]);

  const verifyRegistration = useCallback(async (comment = '') => {
    try {
      const updatedChild = await childApi.verifyRegistration(childId, comment);
      const mappedData = mapChildToComponentData(updatedChild);
      setChild(mappedData);
      return mappedData;
    } catch (err) {
      setError(err.response?.data?.message || 'Помилка перевірки реєстрації');
      throw err;
    }
  }, [childId]);

  const setRegistrationManual = useCallback(async (comment = '') => {
    try {
      const updatedChild = await childApi.setRegistrationManual(childId, comment);
      const mappedData = mapChildToComponentData(updatedChild);
      setChild(mappedData);
      return mappedData;
    } catch (err) {
      setError(err.response?.data?.message || 'Помилка встановлення реєстрації');
      throw err;
    }
  }, [childId]);

  const downloadFile = useCallback(async (childId, fileId, path, fileName) => {
    try {
      await fileApi.downloadFile(childId, fileId, path, fileName);
    } catch (err) {
      setError(err.response?.data?.message || 'Помилка завантаження файлу');
      throw err;
    }
  }, []);

  useEffect(() => {
    if (childId) {
      fetchChild();
    }
  }, [childId, fetchChild]);

  return {
    child,
    loading,
    error,
    refetch: fetchChild,
    verifyRegistration,
    setRegistrationManual,
    downloadFile
  };
};